import { JourneyStage } from "@/types/quests"

/**
 * Determina si un stage es navegable basado en el progreso actual
 * Un stage es navegable si:
 * 1. Es el stage actual
 * 2. Es un stage anterior (completado)
 * 3. Todos sus stages anteriores están completados
 *
 * @param index Índice del stage a verificar
 * @param stages Lista de stages del quest
 * @param currentStageIndex Índice del stage actual
 * @param completedStageIds Set de IDs de stages completados
 * @returns boolean indicando si el stage es navegable
 */
export const isStageNavigable = (
  index: number,
  stages: JourneyStage[] | undefined,
  currentStageIndex: number | undefined,
  completedStageIds: Set<string> | undefined,
): boolean => {
  // Si no hay stages, ninguno es navegable
  if (!stages || stages.length === 0) return false

  // Si currentStageIndex es undefined, solo permitir el primer stage
  const currentIdx = currentStageIndex ?? 0

  // El stage actual siempre es navegable
  if (index === currentIdx) return true

  // Si es un stage anterior, verificar si está completado
  if (index < currentIdx) {
    // Si completedStageIds es undefined, ningún stage está completado
    if (!completedStageIds) return false
    return completedStageIds.has(stages[index].id)
  }

  // Si es un stage posterior, verificar si todos los anteriores están completados
  if (index > currentIdx) {
    // Si completedStageIds es undefined, ningún stage está completado
    if (!completedStageIds) return false

    // Verificar que todos los stages anteriores estén completados
    for (let i = 0; i < index; i++) {
      if (!completedStageIds.has(stages[i].id)) {
        return false
      }
    }
    return true
  }

  return false
}
